import { Button, CircularProgress } from "@mui/material";
import { styled } from "@mui/styles";


export const Container = styled("section")(() => ({
    border: "dashed 1.2px #e8e8e8",
    margin: 5,
    width: "100%",
    textAlign: "center",
}));

export const ButtonContainer = styled(Button)(() => ({
    borderRadius: 6,
    border: "solid 1.2px #e8e8e8",
    backgroundColor: "#ffffff",
    marginTop: 10,
    display: `${(props) => (props.readOnly ? "none" : "")}`,
}));

export const ButtonProgress = styled(CircularProgress)(() => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
}));
